import { Attr, BelongsTo, Model } from "spraypaint";

import type Website from "shared/resources/Website";
import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class Article extends ApplicationRecord {
  static jsonapiType = "articles";

  @Attr() authorName: string;

  @Attr() body: string;

  @Attr() cisionSource: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() live: boolean;

  @Attr() ogDescription: string;

  @Attr() ogImage: string;

  @Attr({ persist: false }) plainTextUrl: string;

  @Attr({ persist: false }) publicLink: string;

  @Attr() publishedAt: string;

  @Attr() removed: boolean;

  @BelongsTo() source: Website;

  @Attr() title: string;

  @Attr() translatedBody: string;

  @Attr() translatedTitle: string;

  @Attr({ persist: false }) type: string;

  @Attr() ucpId: string;

  @Attr() url: string;
}

export default Article;
